import Vue from "vue";
import Router from "vue-router";

import Landing from "@/views/Landing.vue";
import Intro from "@/views/enrollment/Intro.vue";
import Eligibility from "@/views/enrollment/Eligibility.vue";
import Ineligible from "@/views/enrollment/Ineligible.vue";
import IneligiblePending from "@/views/enrollment/IneligiblePending.vue";
import AccountSetup from "@/views/enrollment/AccountSetup.vue";
import Login from "@/views/Login.vue";
import Profile from "@/views/Profile.vue";
import Onboarding from "@/views/enrollment/Onboarding.vue";
import Consent from "@/views/enrollment/Consent.vue";
import NoConsent from "@/views/enrollment/NoConsent.vue";
import Chat from "@/views/Chat.vue";
import Summary from "@/views/Summary.vue";
import LockedSummary from "@/views/LockedSummary.vue";
import OpenModal from "@/views/openmodal.vue"; 
import myChat from "@/views/myChat.vue";
import About from "@/views/About.vue";

Vue.use(Router);

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/",
      name: "landing_page",
      component: Landing
    },
    {
      path: "/intro",
      name: "intro_page",
      component: Intro
    },
    {
      path: "/eligibility",
      name: "eligibility_page",
      component: Eligibility
    },
    {
      path: "/ineligible",
      name: "ineligible_page",
      component: Ineligible
    },
    {
      path: "/ineligible/pending",
      name: "ineligible_pending_page",
      component: IneligiblePending
    },
    {
      path: "/accountsetup/:accessCode",
      name: "accountsetup_page",
      component: AccountSetup,
      props: true
    },
    {
      path: "/consent/:accessCode",
      name: "consent_page",
      component: Consent,
      props: true
    },
    {
      path: "/noconsent",
      name: "noconsent_page",
      component: NoConsent
    },
     {
      path: "/login/",
      name: "login_page",
      component: Login
    },
    {
      path: "/profile",
      name: "profile_page",
      component: Profile
    },
    {
      path: "/onboarding/",
      name: "onboarding_page",
      component: Onboarding
    },
    {
      path: "/openmodal",
      name: "openmodal_page",
      component: OpenModal
    },
    {
      path: "/chat",
      name: "chat",
      component: Chat
    },
    {
      path: "/chat/:section/:startID/",
      name: "chat-section",
      component: Chat,
      props: true
    },
    {
      path: "/summary/locked",
      name: "summary_locked_page",
      component: LockedSummary,
      props: true
    },
    {
      path: "/summary/:mode",
      name: "summary_page",
      component: Summary,
      props: true
    },
    {
      path: "/mychat",
      name: "mychat",
      component: myChat
    },
    
    {
      path: "/about",
      name: "about",
      component: About
    },
    
  ]
});
